import { ComponentType, ReactNode } from 'react'
import { useTranslation } from 'react-i18next'
import { userOptionsStore } from '~/shared/api'
import { TaxiparkCountryEnum } from '~/shared/config/enums'
import { NotFound } from '~/shared/ui/NotFound'

type CountryBasedComponentProps = {
  components: Partial<Record<TaxiparkCountryEnum, ComponentType>>
  fallback?: ReactNode
}

export function CountryBasedComponent({
  components,
  fallback,
}: CountryBasedComponentProps) {
  const { t } = useTranslation()
  const country = userOptionsStore.country

  const Component = country && components[country]

  if (!Component) {
    const DefaultComponent = components[TaxiparkCountryEnum.RU]

    return (
      <>
        {fallback ||
          (DefaultComponent ? (
            <DefaultComponent />
          ) : (
            <NotFound
              message={t(
                'alert.the page is not supported for the current country',
              )}
            />
          ))}
      </>
    )
  }

  return <Component />
}
